import React from 'react';
import { Route } from 'react-router';
import createCustomRoute from 'hocs/createCustomRoute';
import MyApp from './components/MyApp';
import AppMarket from './components/AppMarket';
import AppLearnMore from './components/AppLearnMore';
import OpenPlatform from './components/OpenPlatform';

const AppRoutes = createCustomRoute('AppRoutes', props => (
  <Route {...props} component={OpenPlatform}>
    <Route path="app-market" component={AppMarket} />
    <Route path="my-app" component={MyApp} />
    <Route path=":id/learn-more" component={AppLearnMore} />
  </Route>
));

export default AppRoutes;
